module.exports = __webpack_public_path__ + "un-tenanted-deployment-logo.938c3b504dcc1234028a44b839fe042e.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/tenants/un-tenanted-deployment-logo.png
// module id = 1274
// module chunks = 1